import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IPatient, ICarePlan, ICodeableConcept } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'inc-care-plan-add',
  templateUrl: './care-plan-add.component.html',
  styleUrls: ['./care-plan-add.component.scss'],
})
export class CarePlanAddComponent extends AbstractAddComponent<ICarePlan> implements OnInit {
  @Input() patient: IPatient;
  @Input() careplanCodes: ICodeableConcept[];
  @Input() isModal: boolean;
  @Input() user: any;

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    this.setFormValue();
  }

  setFormValue() {
    this.form.controls.subject.setValue({ display: this.patient.name[0].text, reference: this.patient.id });
    if (this.user) {
      this.form.controls.author.setValue({
        reference: this.user.uid,
        display: this.user.displayName
      });
      if (this.inData) {
        this.form.patchValue(this.inData);
        this.form.patchValue({
          category: [this.careplanCodes.filter(value => value.text === this.inData.category[0].text)[0]]
        });
      } else if (this.careplanCodes) {
        this.form.patchValue({
          category: [this.careplanCodes[0]]
        });
      }
    }
  }

  close(data?: ICarePlan) {
    if (data) {
      data.created = new Date().toISOString();
    }
    if (this.isModal) {
      data ? this.modalController.dismiss(data) : this.modalController.dismiss();
    } else {
      this.save(data);
    }
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      title: new FormControl(''),
      status: new FormControl('active'),
      intent: new FormControl('proposal'),
      category: new FormArray([
        new FormControl()
      ]),
      subject: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      created: new FormControl(new Date().toISOString()),
      author: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      period: new FormGroup({
        start: new FormControl(''),
        end: new FormControl('')
      }),
      goal: new FormControl(),
      supportingInfo: new FormControl()
    });
  }

}
